module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#353a48\"></path><circle cx=\"12\" cy=\"11\" fill=\"#ed0006\" r=\"6\"></circle><circle cx=\"21\" cy=\"11\" fill=\"#f9a000\" r=\"6\"></circle><path d=\"M16.5 7a5.731 5.731 0 011.597 4 5.731 5.731 0 01-1.597 4 5.731 5.731 0 01-1.597-4c0-1.567.612-2.983 1.597-4z\" fill=\"#ff8150\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/credit-cards/asda-credit-card-mastercard.svg
// module id = 666
// module chunks = 0